import { render, staticRenderFns } from "./EmailTemplateTipTapEditor.vue?vue&type=template&id=4e1d4860&"
import script from "./EmailTemplateTipTapEditor.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateTipTapEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateTipTapEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports